import React from 'react';
import DigitalTwinViewer from './DigitalTwinViewer';

const Custom3DViewer: React.FC = () => {
  return <DigitalTwinViewer />;
};

export default Custom3DViewer;